var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-form"},[_c('button',{staticClass:"submit-form-button",attrs:{"autocomplete":"off","type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.validateBtns(), _vm.validateAll()}}},[_vm._v("Pošlji")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0996d74c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Submit.vue
// module id = null
// module chunks = 